import React, {Component} from "react";
import {Menu, Dropdown} from "antd";

import About from "./Help/About";
import Reward from "./Help/Reward";
import Shop from "./Help/Shop";

import "./common.css";

const menu = (
  <Menu>
    <Menu.Item>
      <About />
    </Menu.Item>
    <Menu.Item>
      <Reward />
    </Menu.Item>
    <Menu.Item>
      <Shop />
    </Menu.Item>
  </Menu>
);

class Help extends Component {
  render() {
    return (
      <Dropdown overlay={menu} trigger={["click"]} overlayClassName="nice-overlay">
        <a id="nice-menu-help" className="nice-menu-link" href="#">
          帮助
        </a>
      </Dropdown>
    );
  }
}

export default Help;
